const HOSPITAL_STATS_CHART_PROPS = {
  patientAgeGroup: {
    dataLabels: ["Child", "Adult", "Adolescent"],
    colors: ["#2563eb", "#0f766e", "#0284c7"],
    legend: {
      show: false,
    },
  },
  referralSources: {
    title: "Referral Sources",
    dataLabels: [
      "Physician / Specialist",
      "Word of Mouth",
      "Instagram",
      "Facebook",
      "Internet Search",
      "Podcast",
      "iHeart Radio",
      '"Disconnected Kids" Book',
      "Other",
    ],
    colors: [
      "#2563eb",
      "#0f766e",
      "#0284c7",
      "#f59e0b",
      "#7c3aed",
      "#ef4444",
      "#0891b2",
      "#475569",
      "#94a3b8",
    ],
    legend: {
      show: false,
    },
  },
  doctorAsmtForms: {
    title: "Doctor Assessments Completed",
    width: 450,
    xaxis: {
      title: "",
      categories: [""],
    },
    yaxis: {
      min: 0,
      max: undefined,
      title: "Count",
    },
    annotations: {
      yaxis: [],
    },
  },
  enrollmentSessions: {
    title: "Enrollment Sessions Completed",
    width: 450,
    xaxis: {
      title: "",
      categories: [""],
    },
    yaxis: {
      min: 0,
      max: undefined,
      title: "Count",
    },
    annotations: {
      yaxis: [],
    },
  },
};
export default HOSPITAL_STATS_CHART_PROPS;
